export type TarsMessage = {
  role: "user" | "assistant";
  content: string;
};

type TarsMessages = TarsMessage[]

type TarsState = {
  messages: TarsMessages
  lastPromptId: string | null
  isLoading: boolean
}

const initialState: TarsState = {
  messages: [],
  lastPromptId: "",
  isLoading: false,
};

export function tarsReducer(
  state = initialState,
  action: TarsAction
): TarsState {
  switch (action.type) {
    case 'APPEND_MESSAGE': {
      return {
        ...state,
        messages: [...state.messages, action.payload.message],
      }
    }
    case 'ASSISTANT_COMPLETION': {
      const { content, isCompletionEnd } = action.payload
      const messages = [...state.messages]
      const lastMessage = messages[messages.length - 1]

      if (!lastMessage) {
        return state
      }

      if (lastMessage.role === 'user' && content) {
        messages.push({ role: 'assistant', content })
      } else if (content) {
        lastMessage.content += content
      }

      return {
        ...state,
        messages,
        isLoading: !isCompletionEnd
      }
    }
    case 'SET_LAST_PROMPT_ID': {
      return {
        ...state,
        lastPromptId: action.payload,
        isLoading: true,
      }
    }
    case 'CLEAR_MESSAGES': {
      return initialState
    }
    default:
      return state
  }
}

/* ACTIONS */
type TarsAction = {
  type: "APPEND_MESSAGE"
  payload: {
    promptId: string
    message: TarsMessage
  }
} | {
  type: "ASSISTANT_COMPLETION"
  payload: {
    content: string
    isCompletionEnd: boolean
  }
} | {
  type: "SET_LAST_PROMPT_ID",
  payload: string
} | {
  type: "CLEAR_MESSAGES"
}

/* ACTION CREATORS */
export function appendMessageAction(payload: { message: TarsMessage, promptId: string }) {
  return {
    type: 'APPEND_MESSAGE',
    payload
  }
}

export function setLastPromptId(promptId: string) {
  return {
    type: 'SET_LAST_PROMPT_ID',
    payload: promptId
  }
}

export function assistantCompletion(payload: { content: string, isCompletionEnd: boolean }) {
  return {
    type: 'ASSISTANT_COMPLETION',
    payload
  }
}

export function clearMessages() {
  return { type: 'CLEAR_MESSAGES' }
}
